import React, { useContext, useEffect, useState } from 'react';
import { Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/react';
import { FocusedNodeContext } from '../../Service/Context/FocusedNode';
import { InputHelp } from './InputHelp';
import { useMantineTheme } from '@mantine/core';

export const HTMLEditableText = ({
  finishCallback,
  value: initialValue,
  placeholder,
  patchField,
  style,
  labelStyle,
  preserveHtmlFormatting: _preserveHtmlFormatting,
  deferFinish = false,
  ...rest
}) => {
  const { colorScheme, colors } = useMantineTheme();
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const { setListPosition } = useContext(FocusedNodeContext);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  function focusNode(e) {
    setListPosition(rest.index);
  }

  const styles = {
    error: {
      borderColor: 'red',
    },
    input: {
      marginBottom: 0,
      padding: 5,
      height: 300,
      width: '100%',
      backgroundColor: colorScheme === 'dark' ? colors.dark[6] : 'white',
      color: colorScheme === 'dark' ? '#fff' : '#000',
      border: `1px solid ${colorScheme === 'dark' ? colors.dark[5] : colors.gray[2]}`,
    },
    label: {
      color: '#8ca3b5',
      fontWeight: 800,
      ...labelStyle,
    },
    inputContainer: {
      marginBottom: 9,
      color: 'red',
      ...style,
    },
  };

  return (
    <div style={styles.inputContainer}>
      {placeholder && (
        <Label sm={12} style={styles.label}>
          <Trans id={placeholder} />
        </Label>
      )}
      <textarea
        onBlur={() => {
          const persist = () => {
            setLoading(true);
            finishCallback({ [patchField]: value })
              .catch((error) => setError(error.message))
              .finally(() => {
                setLoading(false);
              });
          };

          if (deferFinish) {
            window.setTimeout(persist, 0);
            return;
          }

          persist();
        }}
        className={loading ? 'loading' : ''}
        style={error ? { ...styles.error, ...styles.input } : styles.input}
        onFocus={focusNode}
        onChange={(e) => setValue(e.target.value)}
        onKeyUp={(e) => {
          switch (e.key) {
            case 'Escape':
              finishCallback({ [patchField]: initialValue })
                .catch((error) => setError(error.message))
                .then(() => setLoading(false));
          }
        }}
        value={value != null ? value : ''}
        {...rest}
      />
      {error ? <InputHelp errorDescription={error} /> : null}
    </div>
  );
};

HTMLEditableText.propTypes = {
  value: PropTypes.string,
  finishCallback: PropTypes.func,
  autoFocus: PropTypes.bool,
  preserveHtmlFormatting: PropTypes.bool,
  deferFinish: PropTypes.bool,
};

HTMLEditableText.defaultProps = {
  autoFocus: true,
  deferFinish: false,
};
